import ModalFilters from '@/language/pt/components/filter/ModalFilters';

export default {
  ModalFilters,
};
